var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.submissionData && _vm.submissionData.licenseAttestFlag === false
        ? _c(
            "v-alert",
            {
              staticClass: "mb-2",
              attrs: {
                type: "warning",
                icon: "warning",
                variant: "outlined",
                value: true
              }
            },
            [
              _vm._v(
                "\n    This service log is pending submission. Please select the Provider Signature to complete and submit the log.\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pageReady
        ? _c(
            "div",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "text-xs-left": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-icon", [_vm._v("mdi-account-card-details")]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "header-class" }, [
                        _vm._v("Student Info")
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("action-icons", {
                        attrs: {
                          fromDashboard: _vm.fromDashboard,
                          submission: _vm.submission
                        },
                        on: { "service-log:deleted": _vm.handleSlDeleted }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Name:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.studentFirstName) +
                                "\n            " +
                                _vm._s(_vm.submissionData.studentLastName) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            ID:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.studentExtId) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            School:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.studentSchoolName) +
                                " (" +
                                _vm._s(_vm.submissionData.schoolCode) +
                                ")\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Gender:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.gender) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Grade:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.grade) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Birthdate:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatDate")(
                                    _vm.submissionData.birthDate
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "divider-class" }),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", "text-xs-left": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-icon", [_vm._v("mdi-file-document")]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "header-class" }, [
                        _vm._v("Service Info")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Service Type:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.planTypeName) +
                                "\n            " +
                                _vm._s(_vm.submissionData.serviceType) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm.isMobile
                              ? _c("span", [_vm._v("Proj. Start Date:")])
                              : _c("span", [_vm._v("Projected Start Date:")])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatDate")(
                                    _vm.submissionData.serviceStartDate
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm.isMobile
                              ? _c("span", [_vm._v("Proj. End Date:")])
                              : _c("span", [_vm._v("Projected End Date:")])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatDate")(
                                    _vm.submissionData.serviceEndDate
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Frequency:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.frequency) +
                                "\n            "
                            ),
                            _vm.submissionData.serviceEsy
                              ? _c("span", [_vm._v("(ESY)")])
                              : _vm._e()
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v(
                              "\n            Service Provider:\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.submissionData.providerFirstName +
                                    " " +
                                    _vm.submissionData.providerLastName
                                ) +
                                "\n            "
                            ),
                            _vm.submissionData.providerCredential
                              ? _c("span", [
                                  _vm._v(
                                    "\n              /\n              " +
                                      _vm._s(
                                        _vm.submissionData.providerCredential
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "divider-class" }),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", "text-xs-left": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-icon", [_vm._v("mdi-calendar-text")]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "header-class" }, [
                        _vm._v("Session Info")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Session Date:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatDate")(
                                    _vm.submissionData.sessionDate
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.hideFields
                        ? _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                                _vm._v(
                                  "\n            Start Time (Length):\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("militaryTimeToStandard")(
                                        _vm.submissionData.sessionTime
                                      )
                                    ) +
                                    "\n            (" +
                                    _vm._s(_vm.submissionData.sessionMinutes) +
                                    " mins)\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Level of Need:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.needLevelName) +
                                "\n            "
                            ),
                            _vm.submissionData.noShow
                              ? _c("span", [_vm._v("(No Call/No Show)")])
                              : _vm._e()
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                            _vm._v("\n            Location:\n          ")
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.locationName) +
                                "\n            "
                            ),
                            _vm.submissionData.locationOther
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.submissionData.locationOther)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.submissionData.bus
                              ? _c("span", [_vm._v("(Bus)")])
                              : _vm._e()
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.submissionData.deliveryModeName
                        ? _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                                _vm._v(
                                  "\n            Delivery Mode:\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.submissionData.deliveryModeName
                                    ) +
                                    "\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.submissionData.roomName
                        ? _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                                _vm._v(
                                  "\n            Classroom Number:\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.submissionData.roomName) +
                                    "\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "divider-class" }),
              _vm._v(" "),
              !_vm.hideFields
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", "text-xs-left": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-icon", [_vm._v("mdi-calendar-plus")]),
                          _vm._v(" "),
                          _c("h3", { staticClass: "header-class" }, [
                            _vm._v("Documentation of Service")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: {
                            mobile: _vm.isMobile,
                            desktop: !_vm.isMobile
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs5: "", md3: "" } }, [
                                _vm.isMobile
                                  ? _c("span", [_vm._v("Total Reimb. Mins:")])
                                  : _c("span", [
                                      _vm._v("Total Reimbursable Minutes:")
                                    ])
                              ]),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.submissionData.medicaidMinutes) +
                                    " mins\n          "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.submissionData.medicaidSessions.length
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.submissionData.medicaidSessions,
                                  function(session, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticStyle: { "margin-top": "15px" }
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "", md3: "" } },
                                              [
                                                session.startTime
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "Start Time (Length):"
                                                      )
                                                    ])
                                                  : _c("span", [
                                                      _vm._v("Minutes:")
                                                    ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs7: "", md9: "" } },
                                              [
                                                session.startTime
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatStartTimeLength(
                                                            session.startTime,
                                                            session.minutes
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          session.minutes
                                                        ) + " mins"
                                                      )
                                                    ])
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "", md3: "" } },
                                              [
                                                _vm._v(
                                                  "\n                Procedure Description:\n              "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs7: "", md9: "" } },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "createProcedureStringFromArray"
                                                      )(session.procedures)
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "", md3: "" } },
                                              [
                                                _vm._v(
                                                  "\n                Outcome:\n              "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs7: "", md9: "" } },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(session.outcome) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideFields
                ? _c("v-divider", { staticClass: "divider-class" })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", "text-xs-left": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-icon", [_vm._v("mdi-clipboard-text")]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "header-class" }, [
                        _vm._v("Notes")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs7: "", md9: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.submissionData.notes) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "divider-class" }),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", "text-xs-left": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-icon", [_vm._v("mdi-paperclip")]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "header-class" }, [
                        _vm._v("Attachments")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                    [
                      _vm.submissionData.files.length
                        ? _c(
                            "div",
                            _vm._l(_vm.submissionData.files, function(
                              file,
                              index
                            ) {
                              return _c(
                                "v-layout",
                                { key: index, attrs: { row: "", wrap: "" } },
                                [
                                  _c("span", { staticClass: "pr-3" }, [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.getAttachment(
                                              file.attachmentId
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(file.fileName) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteAttachment(
                                                file.attachmentId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                mdi-close-circle-outline\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.submissionData.canEdit
                        ? _c(
                            "span",
                            [
                              _c("vue-dropzone", {
                                ref: "myVueDropzone",
                                attrs: {
                                  id: "dropzone",
                                  options: _vm.dropzoneOptions
                                },
                                on: {
                                  "vdropzone-success": function(
                                    file,
                                    response
                                  ) {
                                    _vm.handleResponse(response)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  model: {
                    value: _vm.attachmentsDialog,
                    callback: function($$v) {
                      _vm.attachmentsDialog = $$v
                    },
                    expression: "attachmentsDialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    [_c("v-card-text", [_vm._v(_vm._s(_vm.attachmentData))])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "divider-class" }),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", "text-xs-left": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-icon", [_vm._v("mdi-timer")]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "header-class" }, [
                        _vm._v("Audit Log")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: { mobile: _vm.isMobile, desktop: !_vm.isMobile } },
                    _vm._l(_vm.submissionData.logs, function(log, index) {
                      return _c("div", { key: index }, [
                        _vm._v("\n          " + _vm._s(log.username)),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            _vm._s(log.updateName) +
                              " " +
                              _vm._s(
                                _vm._f("formatDateWithTime")(log.updatedDate)
                              )
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.pageReady
        ? _c(
            "div",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "lds-css ng-scope",
                      attrs: { "fill-height": "" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "lds-spinner",
                          staticStyle: { height: "100%" }
                        },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div")
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8684dafe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8684dafe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/history/confirmation-page/confirmation-page.vue
// module id = null
// module chunks = 